import { render, staticRenderFns } from "./note.vue?vue&type=template&id=747c09c1&lang=pug&"
import script from "./note.vue?vue&type=script&lang=js&"
export * from "./note.vue?vue&type=script&lang=js&"
import style0 from "./note.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports